import axiosInstance from "./axiosInstance";
import { axiosInstanceFast } from "./axiosInstance";
import {
  IncidentProps,
  EventDetailProps,
} from "@pages/homepage/aml-anomaly-detection/AmlAnomalyTypes";
import { CLICK_LOG_KEY } from "@utils/utils";
import i18n from "@i18n/i18n";

export const incidentOverview = async (
  data: IncidentProps,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/incident-details",
    data,
    { signal },
  );
  return response.data;
};

export const getEventDetail = async (
  data: EventDetailProps,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.get("/anomaly/event-details", {
    params: data,
    signal,
  });
  return response.data.data;
};

export const getPeerUsers = async (
  data: {
    username: string;
    source?: string;
    subSource?: string;
    tenantId?: string;
  },
  signal?: AbortSignal,
) => {
  // const response = await axiosInstance.post('/peerUsers/', {"username": username});
  const response = await axiosInstanceFast.post("/user/peer-users", data, {
    signal,
  });
  return response.data.data;
};

export const userEntitySessions = async (
  username: string,
  filterTime: string,
  signal?: AbortSignal,
) => {
  // const response = await axiosInstance.post('/userEntitySessions/', {"username": username, "filterTime": filterTime});
  const response = await axiosInstanceFast.post(
    "/user/user-entity-sessions/",
    {
      account: username,
      filterTime: filterTime,
    },
    { signal },
  );
  return response.data.data;
};

export const shadowGPTSearch = async (
  search: string,
  shadowGPTFlag: string,
) => {
  const response = await axiosInstance.post("/advancedSearch/", {
    advancedSearchInput: search,
    shadowGPT: shadowGPTFlag,
  });
  return response.data.data;
};

export const getPluginFrontend = async (
  url: string,
  data: {
    template: string;
    user: string;
    dataFunction: string;
    filterTime: string;
  },
) => {
  const response = await axiosInstance.post(url, data);
  return response.data;
};

export const getAnomalyInfo = async (anomalyId: number) => {
  const response = await axiosInstance.post("/getAnomalyInfo/", {
    anomalyId: anomalyId,
  });
  return response.data;
};

export const getuserDetails = async (data: {
  account: string;
  filterTime?: string;
  watched?: number;
  serviceAccount?: number;
  whitelist?: number;
  is_super_admin?: string;
  is_external?: number;
  plugin_id?: string;
  tenant_id?: string;
}) => {
  // const response = await axiosInstance.post('/userdetails/', data);
  const response = await axiosInstanceFast.post("/user/user-details", data);
  return response.data.data;
};

export const getAvailablePluginCategories = async (target: string) => {
  const response = await axiosInstance.post("/getAvailablePluginCategories/", {
    target: target,
  });
  return response.data;
};

export const loadJsonData = async (filePath: string) => {
  const response = await axiosInstance.get(filePath);
  return response.data;
};

export const getSearchResults = async (
  searchText: string,
  productType: string,
  global_flag: boolean,
  signal?: AbortSignal,
) => {
  // check if the input text is ip
  const partialIpRegex = /^(\d{1,3}\.){0,3}\d{0,3}$/;
  const partialMacRegex = /^([0-9A-Fa-f]{0,2}[:-]){0,5}[0-9A-Fa-f]{0,2}$/;
  const entityQueryData = {
    filterTime: "day",
    page: 1,
    size: 5,
    searchText: searchText,
    // "sortKey": "title",
    // "sortOrder": "asc",
    // "forReport": false,
    // "watched": 1,
    flag: 1,
    sortKeyOn: "default",
    defaultAttrs: ["hostname"],
    globalFlag: global_flag,
  };
  if (partialIpRegex.test(searchText) || partialMacRegex.test(searchText)) {
    const response = await axiosInstanceFast.post(
      "/entity/entities",
      entityQueryData,
      { signal },
    );
    return {
      entities: response.data.data && response.data.data.assetList,
      users: [],
      files: [],
    };
  } else {
    const user_query_data = {
      page: 1,
      size: 5,
      filterTime: "day",
      // "customFilter": "False",
      // "dataSource": "active_directory",
      searchText: searchText,
      // "fromDate": 1717423213,
      // "toDate": 1717423213,
      // "sortKey": "title",
      // "sortOrder": "asc",
      // "searchFlag": 3,
      // "watched": 1,
      sortKeyOn: "default",
      defaultAttrs: [
        "username",
        "source",
        "sub_source",
        "last_logon_time",
        "is_critical",
        "is_watched",
        "is_service_account",
        "department",
        "display_name",
      ],
      globalFlag: global_flag,
    };

    const promises = [
      axiosInstanceFast.post("/entity/entities", entityQueryData, { signal }),
      axiosInstanceFast.post("/user/users", user_query_data, { signal }),
    ];
    if (productType == "ddr") {
      promises.push(
        axiosInstanceFast.get(
          `/rdd/backend/v1/file/search?name=${searchText}&limit=5&offset=0`,
          { signal },
        ),
      );
    }
    const [assetRes, userRes, fileRes] = await Promise.all(promises);
    return {
      entities: assetRes.data.data && assetRes.data.data.assetList,
      users: userRes.data.data && userRes.data.data.results,
      files: productType === "ddr" ? fileRes.data : [],
    };
  }
};

export const getSystemId = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/system/get-system-id", {
    signal,
  });
  return response.data.data;
};

export const CheckDownloadReport = async () => {
  const response = await axiosInstance.post("/SearchDownloadReport/");
  return response.data;
};

export const fetchDeviceProperties = async () => {
  const response = await axiosInstance.post("/fetchDeviceProperties/");
  return response.data;
};

export const fetchSelectedLanguage = async () => {
  const response = await axiosInstance.post("/getSelectedLanguage/");
  i18n.changeLanguage(response?.data?.language);
  return response.data;
};

export const getSystemArchitectureInfo = async (signal?: AbortSignal) => {
  const response = await axiosInstance.post(
    "/getSystemArchitectureInfo/",
    {},
    { signal },
  );
  return response.data;
};

export const getDistributedDashboardInfo = async (
  filterTime: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/distributedDashboard/",
    { filterTime },
    { signal },
  );
  return response.data;
};

export const getDistributedDashboardData = async (
  filterTime: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/system/distributed-system-dashboard",
    filterTime,
    { signal },
  );
  return response.data.data;
};

export const setDistributedSystemIpSession = async (data: {
  ip: string;
  distributed_systems_type: string;
  device_name: string;
}) => {
  const response = await axiosInstance.post(
    "/setDistributedSystemIp/",
    data,
    // { signal },
  );
  return response.data;
};

export const uploadLicenseToSensor = async (data: FormData) => {
  const response = await axiosInstance.post("/uploadLicenseToSensor/", data);
  return response.data;
};

export const updateAnalyticsData = async () => {
  const data = JSON.parse(localStorage.getItem(CLICK_LOG_KEY) || "[]") || [];
  if (data.length === 0) {
    return { success: true, message: "No click data to update." };
  }
  const response = await axiosInstance.post(
    "/updateAnalyticsData/",
    JSON.stringify({ data: data }),
    {
      headers: { "Content-Type": "application/json" },
    },
  );
  localStorage.setItem(CLICK_LOG_KEY, JSON.stringify([]));
  return response.data;
};

export const getUserAttributes = async (
  is_custom: boolean,
  all: boolean = false,
) => {
  let url = "/user/attributes/?is_custom=" + is_custom;
  if (all) {
    url = "/user/attributes";
  }
  const response = await axiosInstanceFast.get(url);
  return response.data.data;
};

export const getEntityAttributes = async (is_custom: boolean) => {
  const response = await axiosInstanceFast.get(
    "/entity/attributes/?is_custom=" + is_custom,
  );
  return response.data.data;
};

export const getAllPermissions = async () => {
  const response = await axiosInstance.get("/getAllPermissions/");
  return response.data;
};

export const getOtherUserAttributes = async (
  data: { username: string; plugin_id?: string },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/user/other-ls-attributes",
    data,
    { signal },
  );
  return response.data.data;
};

export const getOtherEntityAttributes = async (
  data: { macAddress: string },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/entity/other-ls-attributes",
    data,
    { signal },
  );
  return response.data.data;
};

export const getHeaderFooter = async (signal?: AbortSignal) => {
  const response = await axiosInstance.get("/getheaderfooter/", { signal });
  return response.data;
};

export const writeUserLog = async (data: {
  logType: string;
  logDescription: string;
}) => {
  const response = await axiosInstance.post("/writeUserLog/", data);
  return response.data;
};

export const getUserDetailsAnomalies = async (
  data: {
    account: string;
    filterTime: string;
    source?: string;
    subSource?: string;
    load_events?: boolean;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/user/user-details-anomalies",
    data,
    {
      signal,
    },
  );
  return response.data.data;
};

export const getAutomationData = async () => {
  const response = await axiosInstance.post("/getAutomationData/", {});
  return response.data;
};

export const getPluginFrontendUI = async (id: string, pluginSettings?: any) => {
  const data = {
    template: pluginSettings.template,
    pluginSettings: pluginSettings || {},
    actionId: pluginSettings.actionId,
    templateFunction: "get_plugin_action_frontend_template",
  };

  const response = await axiosInstanceFast.post(
    `/plugin/${id}/template/actions.html/`,
    data,
  );

  return response.data;
};
